<footer class="inner_f_i" id="footer">
    <div class="container">
        <div class="row mt-5 fpad100">
            <div class="col-md-3 footer-nav">
                <label>{{'company' | translate}}</label>
                <ul>
                    <li><a href="javascript:;" routerLink="/aboutus">{{'aboutUs.title' | translate}}</a></li>
                    <li><a href="javascript:;">{{'news' | translate}}</a></li>
                </ul>
            </div>
            <div class="col-md-3 footer-nav">
                <label>{{'support' | translate}}</label>
                <ul>
                    <li><a href="javascript:;" routerLink="/contactus">{{'contactUs' | translate}}</a></li>
                    <li><a href="javascript:;" routerLink="/faq">{{'faqs.title' | translate}}</a></li>
                </ul>
            </div>
            <div class="col-md-3 footer-nav">
                <label>{{'legal' | translate}}</label>
                <ul>
                    <li><a href="javascript:;" routerLink="/terms">{{'termsOfUse' | translate}}</a></li>
                    <li><a href="javascript:;" routerLink="/policy">{{'privacyPolicy.title' | translate}}</a></li>
                </ul>
            </div>
            <div class="col-md-3 footer-social">
                <img class="f-logo" src="/assets/img/logo.png" />
                <ul>
                    <li><a><img src="/assets/img/Icon/facebook.svg" /></a></li>
                    <li><a><img src="/assets/img/Icon/instagram.svg" /></a></li>
                    <li><a><img src="/assets/img/Icon/linkedin.svg" /></a></li>
                    <li><a><img src="/assets/img/Icon/youtube.svg" /></a></li>
                </ul>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12 footer-bottom">
                <h6 class="text-white text-center">{{'availableOnManyDevicesInstallNow' | translate}}</h6>
                <ul>
                    <li><a target="_blank" href="https://play.google.com/store/apps/details?id=com.digivive.offdeck"><img src="/assets/img/Icon/google-play.svg" /></a></li>
                    <li><a target="_blank" href="https://apps.apple.com/in/app/nexgtv-live-tv-movies-videos/id495146199"><img src="/assets/img/Icon/app-store.svg" /></a></li>
                    <li><a target="_blank" href="https://play.google.com/store/apps/details?id=com.digivive.androidtv"><img src="/assets/img/Icon/android-tv.svg" /></a></li>
                    <li><a target="_blank" href="https://www.amazon.com/Digivive-Services-Pvt-Ltd-nexGTv/dp/B01N3UO97B/ref=sr_1_1?dib=eyJ2IjoiMSJ9.qPgdFxvkzN4JAWF3lO_EuQ.rLiZCN-4ESUyUELy6Hm8b4EeGTwNyC7HJe4b38DxHu4&dib_tag=se&keywords=nexgtv&qid=1727954533&s=mobile-apps&sr=1-1"><img src="/assets/img/Icon/fire-tv.svg" /></a></li>
                </ul>
                <p>&copy; {{currentYear}}, {{'ottRunByDigiviveAllRightsReserved' | translate}}</p>
            </div>
        </div>         
    </div>        
</footer>